import { render, staticRenderFns } from "./BatchWeightUpdateFormulationPopUp.vue?vue&type=template&id=089ffb07&scoped=true&"
import script from "./BatchWeightUpdateFormulationPopUp.vue?vue&type=script&lang=js&"
export * from "./BatchWeightUpdateFormulationPopUp.vue?vue&type=script&lang=js&"
import style0 from "./BatchWeightUpdateFormulationPopUp.vue?vue&type=style&index=0&id=089ffb07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089ffb07",
  null
  
)

export default component.exports